import moment from 'moment-timezone';
import { Availability, AvailabilityHour } from 'types/Availability';
import { AvailabilityDtos, AvailabilityHourDto } from './AvailabilityDtos';

export const convertAvailabilityData = (
    availabilityDataDto: AvailabilityDtos[],
    timeZone: string
): Availability[] => {
    return availabilityDataDto.map(item => ({
        availableHours: item.available_hours.map(hours => convertHours(hours, timeZone)),
        date: item.date,
        dayName: item.day_name
    }));
};

export const convertHours = (hours: AvailabilityHourDto, timeZone: string): AvailabilityHour => {
    return {
        datetime: moment(hours.datetime).tz(timeZone),
        staffAvailable: hours.staff_available,
        time: hours.time.toLowerCase()
    };
};
